import call from "@kinetics254/cassandra-base/service/http";
import constants from "./constants";

export default {
  namespaced: true,
  state: {
    grievanceCases: [],
    caseTypes: ["Complaint", "Harassment", "Dispute", "Other"],
  },
  mutations: {
    MUTATE: (state, payload) => {
      state[payload.state] = payload.data;
    },
  },
  getters: {
    grievanceGetters: (state) => (val) => state[val],
  },
  actions: {
    getGrievanceCases: ({ commit }) => {
      commit("loader/SET_LOADING", true, { root: true });
      call("get", constants.grievances)
        .then((res) => {
          commit("loader/SET_LOADING", false, { root: true });
          commit("MUTATE", {
            state: "grievanceCases",
            data: res.data.data,
          });
        })
        .catch((error) => {
          Event.$emit("ApiError", error.response.data.message);
          commit("loader/SET_LOADING", false, { root: true });
        });
    },
    addCase: async ({ commit, dispatch }, data) => {
      try {
        await call("post", constants.grievances, data);
        Event.$emit("ApiSuccess", "Grievance case added successfully");
        dispatch("getGrievanceCases");
      } catch (error) {
        Event.$emit("ApiError", error.response.data.message);
        throw error;
      }
    },
    updateCase: async ({ commit, dispatch }, data) => {
      try {
        await call("post", constants.updateGrievance, data);
        Event.$emit("ApiSuccess", "Grievance case updated successfully");
        dispatch("getGrievanceCases");
      } catch (error) {
        Event.$emit("ApiError", error.response.data.message);
        throw error;
      }
    },
    deleteCase: async ({ commit, dispatch }, data) => {
      try {
        await call("post", constants.deleteGrievance, data);
        Event.$emit("ApiSuccess", "Grievance case deleted successfully");
        dispatch("getGrievanceCases");
      } catch (error) {
        Event.$emit("ApiError", error.response.data.message);
        throw error;
      }
    },
    deleteGrievanceAttachment: async ({ commit, dispatch }, data) => {
      try {
        await call("post", constants.deleteGrievanceAttachment, data);
        Event.$emit("ApiSuccess", "Grievance attachment deleted successfully");
        dispatch("getGrievanceCases");
      } catch (error) {
        Event.$emit("ApiError", error.response.data.message);
        throw error;
      }
    },
  },
};
